export const scrollToElement = {
	bind(el, binding) {

		el.addEventListener('click', () => {
			smoothScroll(binding.value, 1000, 0);
		});

		const smoothScroll =(target, duration, offset = 80) => {
			let targetElement  = document.querySelector(target);
			let targetPosition = targetElement.getBoundingClientRect().top;
			let startPosition  = window.pageYOffset;
			let distance       = targetPosition - offset;
			let startTime      = null;

			const animation = (currentTime) => {
				if(startTime === null) {
					startTime = currentTime;
				}
				let timeElapsed = currentTime - startTime;
				let run         = ease(timeElapsed, startPosition, distance, duration);
				window.scrollTo(0, run);
				if(timeElapsed < duration) {
					requestAnimationFrame(animation);
				}
			};

			const ease = (t, b, c, d) => {
				t /= d / 2;
				if(t < 1) {
					return c / 2 * t * t + b;
				}
				t--;
				return -c / 2 * (t * (t - 2) - 1) + b;
			};

			requestAnimationFrame(animation);
		};
	}
};